import React from 'react';
import { MessagesSquare } from 'lucide-react';
import data from '@/lib/agentReadyComments.json';
import { CommentForm } from '@/components/spec/CommentForm';
import { PROMISES } from '@/lib/agentReady';

const SECTIONS = ['General', 'The file itself', ...PROMISES.map(([, label]) => `Promise: ${label}`), 'The checker', 'AX claims and receipts'];

export function AgentReadyComments() {
  return (
    <section className="mt-12 max-w-4xl" data-testid="ar-comments">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2 mb-1"><MessagesSquare className="w-4 h-4 text-amber-300" /> Comments on the five promises</h2>
      <p className="text-sm text-gray-400 mb-5">Builders, vendors, and agent makers: tell us which promise is wrong, missing, or unrealistic. Each comment is read by a person, summarized below, and noted with what changed in the draft.</p>
      <div className="rounded-2xl border border-white/10 bg-black/30 p-5" data-testid="ar-comment-log">
        <div className="text-xs uppercase tracking-widest text-gray-500 mb-3">Comments received ({data.comments.length})</div>
        {data.comments.length === 0 ? (
          <p className="text-sm text-gray-500" data-testid="ar-comment-log-empty">No comments yet. Yours could be the first one listed.</p>
        ) : (
          <ul className="space-y-3">
            {data.comments.map((c) => (
              <li key={c.id} className="text-sm text-gray-300" data-testid={`ar-comment-${c.id}`}>
                <span className="font-mono text-xs text-gray-500">{c.id} {c.date}</span> <span className="text-white">{c.from}</span>, {c.section}: {c.summary} <span className="text-xs text-amber-300">{c.status}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <CommentForm sections={SECTIONS} topic="Agent-Ready File" source="/specs/agent-ready/demo" />
    </section>
  );
}
